'use client';

import AnalyticsIcon from '@mui/icons-material/Analytics';
import BadgeIcon from '@mui/icons-material/Badge';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import InsightsIcon from '@mui/icons-material/Insights';
import LoopIcon from '@mui/icons-material/Loop';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import PsychologyIcon from '@mui/icons-material/Psychology';
import SpeedIcon from '@mui/icons-material/Speed';
import VerifiedIcon from '@mui/icons-material/Verified';
import { Box, Divider, Stack, Typography } from '@mui/material';
const WhyChooseUs = () => {
  return <Box sx={{
    backgroundColor: 'background.paper',
    borderRadius: 4,
    boxShadow: 3,
    p: {
      xs: 4,
      md: 8
    },
    mt: 8
  }} data-sentry-element="Box" data-sentry-component="WhyChooseUs" data-sentry-source-file="WhyChooseUs.tsx">
      <Stack direction={{
      xs: 'column',
      lg: 'row'
    }} spacing={{
      xs: 6,
      lg: 8
    }} alignItems={{
      xs: 'center',
      lg: 'flex-start'
    }} justifyContent="space-between" data-sentry-element="Stack" data-sentry-source-file="WhyChooseUs.tsx">
        {/* Left */}
        <Box flex={1} data-sentry-element="Box" data-sentry-source-file="WhyChooseUs.tsx">
          <Typography variant="h4" fontWeight="bold" mb={4} textAlign={{
          xs: 'center',
          lg: 'left'
        }} component="h2" data-sentry-element="Typography" data-sentry-source-file="WhyChooseUs.tsx">
            Why Choose CertResource Practice Exams?
          </Typography>
          <Stack spacing={3} data-sentry-element="Stack" data-sentry-source-file="WhyChooseUs.tsx">
            <Box sx={{
            display: 'flex',
            alignItems: 'flex-start'
          }} data-sentry-element="Box" data-sentry-source-file="WhyChooseUs.tsx">
              <CheckCircleIcon color="success" sx={{
              mr: 2,
              mt: 0.5
            }} data-sentry-element="CheckCircleIcon" data-sentry-source-file="WhyChooseUs.tsx" />
              <Typography variant="body1" data-sentry-element="Typography" data-sentry-source-file="WhyChooseUs.tsx">
                <strong>Retest your weak areas</strong>
                {' '}
                with focused practice exams.
              </Typography>
            </Box>
            <Box sx={{
            display: 'flex',
            alignItems: 'flex-start'
          }} data-sentry-element="Box" data-sentry-source-file="WhyChooseUs.tsx">
              <VerifiedIcon color="success" sx={{
              mr: 2,
              mt: 0.5
            }} data-sentry-element="VerifiedIcon" data-sentry-source-file="WhyChooseUs.tsx" />
              <Typography variant="body1" component="h3" data-sentry-element="Typography" data-sentry-source-file="WhyChooseUs.tsx">
                <strong>Get the exam RIGHT the first time</strong>
                {' '}
                with targeted learning strategies.
              </Typography>
            </Box>
            <Box sx={{
            display: 'flex',
            alignItems: 'flex-start'
          }} data-sentry-element="Box" data-sentry-source-file="WhyChooseUs.tsx">
              <AnalyticsIcon color="success" sx={{
              mr: 2,
              mt: 0.5
            }} data-sentry-element="AnalyticsIcon" data-sentry-source-file="WhyChooseUs.tsx" />
              <Typography variant="body1" component="h3" data-sentry-element="Typography" data-sentry-source-file="WhyChooseUs.tsx">
                <strong>Track your strengths and weaknesses</strong>
                {' '}
                automatically.
              </Typography>
            </Box>
            <Box sx={{
            display: 'flex',
            alignItems: 'flex-start'
          }} data-sentry-element="Box" data-sentry-source-file="WhyChooseUs.tsx">
              <BadgeIcon color="success" sx={{
              mr: 2,
              mt: 0.5
            }} data-sentry-element="BadgeIcon" data-sentry-source-file="WhyChooseUs.tsx" />
              <Typography variant="body1" component="h3" data-sentry-element="Typography" data-sentry-source-file="WhyChooseUs.tsx">
                <strong>Crafted by certified experts</strong>
                {' '}
                — results-driven, no fluff.
              </Typography>
            </Box>
            <Box sx={{
            display: 'flex',
            alignItems: 'flex-start'
          }} data-sentry-element="Box" data-sentry-source-file="WhyChooseUs.tsx">
              <SpeedIcon color="success" sx={{
              mr: 2,
              mt: 0.5
            }} data-sentry-element="SpeedIcon" data-sentry-source-file="WhyChooseUs.tsx" />
              <Typography variant="body1" component="h3" data-sentry-element="Typography" data-sentry-source-file="WhyChooseUs.tsx">
                <strong>Perfect for last-minute prep</strong>
                {' '}
                — 200+ updated questions with detailed breakdowns.
              </Typography>
            </Box>
          </Stack>
        </Box>

        {/* Divider for mobile */}
        <Divider orientation="horizontal" flexItem sx={{
        display: {
          xs: 'block',
          lg: 'none'
        },
        width: '100%'
      }} data-sentry-element="Divider" data-sentry-source-file="WhyChooseUs.tsx" />

        {/* Right */}
        <Box flex={1} data-sentry-element="Box" data-sentry-source-file="WhyChooseUs.tsx">
          <Typography variant="h4" fontWeight="bold" component="h2" mb={4} textAlign={{
          xs: 'center',
          lg: 'left'
        }} data-sentry-element="Typography" data-sentry-source-file="WhyChooseUs.tsx">
            What's Included
          </Typography>
          <Stack spacing={3} data-sentry-element="Stack" data-sentry-source-file="WhyChooseUs.tsx">
            <Box sx={{
            display: 'flex',
            alignItems: 'flex-start'
          }} data-sentry-element="Box" data-sentry-source-file="WhyChooseUs.tsx">
              <MenuBookIcon color="primary" sx={{
              mr: 2,
              mt: 0.5
            }} data-sentry-element="MenuBookIcon" data-sentry-source-file="WhyChooseUs.tsx" />
              <Typography variant="body1" component="h3" data-sentry-element="Typography" data-sentry-source-file="WhyChooseUs.tsx">
                <strong>200+ practice questions</strong>
                {' '}
                broken down by domain.
              </Typography>
            </Box>
            <Box sx={{
            display: 'flex',
            alignItems: 'flex-start'
          }} data-sentry-element="Box" data-sentry-source-file="WhyChooseUs.tsx">
              <LoopIcon color="primary" sx={{
              mr: 2,
              mt: 0.5
            }} data-sentry-element="LoopIcon" data-sentry-source-file="WhyChooseUs.tsx" />
              <Typography variant="body1" component="h3" data-sentry-element="Typography" data-sentry-source-file="WhyChooseUs.tsx">
                <strong>Retake only the questions you missed</strong>
                {' '}
                — focus your time where it matters most.
              </Typography>
            </Box>
            <Box sx={{
            display: 'flex',
            alignItems: 'flex-start'
          }} data-sentry-element="Box" data-sentry-source-file="WhyChooseUs.tsx">
              <PsychologyIcon color="primary" sx={{
              mr: 2,
              mt: 0.5
            }} data-sentry-element="PsychologyIcon" data-sentry-source-file="WhyChooseUs.tsx" />
              <Typography variant="body1" component="h3" data-sentry-element="Typography" data-sentry-source-file="WhyChooseUs.tsx">
                <strong>Explanations included</strong>
                {' '}
                for every single question.
              </Typography>
            </Box>
            <Box sx={{
            display: 'flex',
            alignItems: 'flex-start'
          }} data-sentry-element="Box" data-sentry-source-file="WhyChooseUs.tsx">
              <InsightsIcon color="primary" sx={{
              mr: 2,
              mt: 0.5
            }} data-sentry-element="InsightsIcon" data-sentry-source-file="WhyChooseUs.tsx" />
              <Typography variant="body1" component="h3" data-sentry-element="Typography" data-sentry-source-file="WhyChooseUs.tsx">
                <strong>Real-time progress tracking</strong>
                {' '}
                across all exam categories.
              </Typography>
            </Box>
          </Stack>
        </Box>
      </Stack>
    </Box>;
};
export default WhyChooseUs;